// Critical: Optimize Zone.js for defer blocks to reduce CPU spikes
(window as any)['__zone_symbol__PASSIVE_EVENTS'] = [
  'scroll',
  'mousewheel',
  'touchstart',
  'touchmove',
  'touchend',
  'touchcancel',
];

// Disable Zone.js patching for high-frequency events that trigger in defer blocks
(window as any)['__zone_symbol__UNPATCHED_EVENTS'] = [
  'scroll',
  'mousemove',
  'mouseenter',
  'mouseleave',
  'touchmove',
  'pointermove',
  'resize',
  'load',
];

// Disable RAF patching - critical for Swiper performance in defer blocks
(window as any).__Zone_disable_requestAnimationFrame = true;

// Prevent Zone.js from patching IntersectionObserver (used by @defer)
(window as any).__Zone_disable_customElements = true;
